var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CheckCircleRounded, Close, ErrorRounded, FileUploadRounded, UploadFile } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Alert, Avatar, Box, Chip, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Scrollbar } from 'app/components';
import { TransportRoundedIcon } from 'app/icons';
import { downloadTransportTemplate, parseTransportExcel, validateTransportRows, } from 'app/pages/Transport/transportBulkImport';
import { useAsyncAction } from 'app/services';
import { transportBulkCreate, transportGroupLoad } from 'app/store/transport';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
const TransportBulkImportDialog = ({ open, onClose }) => {
    const fileInputRef = useRef(null);
    const [rows, setRows] = useState([]);
    const [fileName, setFileName] = useState('');
    const [parseError, setParseError] = useState('');
    const [isParsing, setIsParsing] = useState(false);
    const items = useSelector((state) => state.transport.items);
    const groupItems = useSelector((state) => state.transport.groupItems);
    const { asyncAction: fetchGroupData } = useAsyncAction(transportGroupLoad);
    const { asyncAction: submitBulk, isLoading: isSubmitLoading, isSuccessful: isSubmitSuccessful, isError: isSubmitError, } = useAsyncAction(transportBulkCreate, [open]);
    const referenceData = useMemo(() => ({
        groupItems,
    }), [groupItems]);
    const validatedRows = useMemo(() => {
        if (!rows.length) {
            return [];
        }
        return validateTransportRows(rows, referenceData, items);
    }, [rows, referenceData, items]);
    const validCount = validatedRows.filter((row) => row.isValid).length;
    const invalidCount = validatedRows.length - validCount;
    const canImport = validatedRows.length > 0 && invalidCount === 0;
    const resetState = () => {
        setRows([]);
        setFileName('');
        setParseError('');
        setIsParsing(false);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    const handleClose = () => {
        resetState();
        onClose();
    };
    const handleTemplateDownload = () => {
        void downloadTransportTemplate(referenceData);
    };
    const handleFileSelect = (event) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file) {
            return;
        }
        setParseError('');
        setIsParsing(true);
        setFileName(file.name);
        try {
            const parsedRows = yield parseTransportExcel(file);
            setRows(parsedRows);
        }
        catch (error) {
            setRows([]);
            setParseError(error instanceof Error ? error.message : 'Не удалось прочитать файл');
        }
        finally {
            setIsParsing(false);
        }
    });
    const handleImport = () => {
        if (!canImport) {
            return;
        }
        submitBulk({
            items: validatedRows.map((row) => row.payload),
        });
    };
    useEffect(() => {
        if (!open) {
            return;
        }
        fetchGroupData();
    }, [open]);
    useEffect(() => {
        if (isSubmitSuccessful) {
            handleClose();
        }
    }, [isSubmitSuccessful]);
    return (React.createElement(Dialog, { maxWidth: 'lg', fullWidth: true, open: open, onClose: handleClose, sx: (theme) => ({
            '.MuiDialog-paper': {
                minWidth: '720px',
                maxHeight: '90vh',
            },
            '.MuiDialogTitle-root': {
                display: 'flex',
                padding: theme.spacing(2),
                alignItems: 'center',
            },
            '.MuiDialogTitle-root .MuiTypography-root': {
                marginLeft: theme.spacing(2),
            },
            '.MuiDialogTitle-root > .MuiIconButton-root:last-of-type': {
                marginLeft: 'auto',
            },
            '.MuiDialogContent-root': {
                padding: theme.spacing(0),
            },
            '.MuiDialogContent-root .simplebar-container': {
                padding: theme.spacing(0, 2, 2),
            },
            '.MuiDialogActions-root': {
                padding: theme.spacing(2),
                justifyContent: 'space-between',
            },
            '.MuiAvatar-circular': {
                bgcolor: alpha(theme.palette.primary.main, 0.12),
                svg: {
                    width: '18px',
                    height: '18px',
                },
                path: {
                    fill: theme.palette.primary.main,
                },
            },
        }) },
        React.createElement(DialogTitle, null,
            React.createElement(Avatar, null,
                React.createElement(TransportRoundedIcon, { fontSize: 'small' })),
            React.createElement(Typography, { component: 'span' }, "\u041F\u0430\u043A\u0435\u0442\u043D\u043E\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430"),
            React.createElement(IconButton, { color: 'default', onClick: handleClose },
                React.createElement(Close, { fontSize: 'small' }))),
        React.createElement(DialogContent, null,
            React.createElement(Scrollbar, null,
                React.createElement(Stack, { spacing: 2, sx: { pt: 1 } },
                    React.createElement(Alert, { severity: 'info' }, "\u0421\u043A\u0430\u0447\u0430\u0439\u0442\u0435 \u0448\u0430\u0431\u043B\u043E\u043D, \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0435\u0433\u043E \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u0430\u0439\u043B. \u041F\u0435\u0440\u0435\u0434 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043C \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u043F\u0440\u0435\u0432\u044C\u044E \u2014 \u0441\u0442\u0440\u043E\u043A\u0438 \u0441 \u043E\u0448\u0438\u0431\u043A\u0430\u043C\u0438 \u0431\u0443\u0434\u0443\u0442 \u043F\u043E\u0434\u0441\u0432\u0435\u0447\u0435\u043D\u044B."),
                    React.createElement(Stack, { direction: 'row', spacing: 1, alignItems: 'center' },
                        React.createElement(LoadingButton, { variant: 'outlined', onClick: handleTemplateDownload, disableElevation: true }, "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0448\u0430\u0431\u043B\u043E\u043D"),
                        React.createElement(LoadingButton, { variant: 'contained', component: 'label', loading: isParsing, startIcon: React.createElement(UploadFile, null), disableElevation: true },
                            "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0444\u0430\u0439\u043B",
                            React.createElement("input", { ref: fileInputRef, hidden: true, type: 'file', accept: '.xlsx,.xls', onChange: handleFileSelect })),
                        fileName && (React.createElement(Typography, { variant: 'body2', color: 'text.secondary' }, fileName))),
                    parseError && React.createElement(Alert, { severity: 'error' }, parseError),
                    !isSubmitLoading && isSubmitError && (React.createElement(Alert, { severity: 'error' }, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u0430\u043A\u0435\u0442\u043D\u043E\u043C \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0438. \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430.")),
                    validatedRows.length > 0 && (React.createElement(Stack, { spacing: 1 },
                        React.createElement(Stack, { direction: 'row', spacing: 1, alignItems: 'center' },
                            React.createElement(Chip, { size: 'small', color: 'success', label: `Готово к импорту: ${validCount}` }),
                            invalidCount > 0 && React.createElement(Chip, { size: 'small', color: 'error', label: `С ошибками: ${invalidCount}` })),
                        React.createElement(TableContainer, { component: Box, sx: (theme) => ({
                                border: '1px solid',
                                borderColor: theme.palette.divider,
                                borderRadius: theme.shape.borderRadius,
                            }) },
                            React.createElement(Table, { size: 'small', stickyHeader: true },
                                React.createElement(TableHead, null,
                                    React.createElement(TableRow, null,
                                        React.createElement(TableCell, { width: 56 }, "\u0421\u0442\u0440\u043E\u043A\u0430"),
                                        React.createElement(TableCell, null, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"),
                                        React.createElement(TableCell, null, "\u0413\u043E\u0441\u043D\u043E\u043C\u0435\u0440"),
                                        React.createElement(TableCell, { width: 90 }, "\u0411\u0430\u043A"),
                                        React.createElement(TableCell, null, "\u0413\u0440\u0443\u043F\u043F\u0430"),
                                        React.createElement(TableCell, { width: 120 }, "IMEI"),
                                        React.createElement(TableCell, { width: 100 }, "\u0422\u0435\u0440\u043C\u0438\u043D\u0430\u043B"),
                                        React.createElement(TableCell, { width: 72 }, "\u0421\u0442\u0430\u0442\u0443\u0441"),
                                        React.createElement(TableCell, null, "\u041E\u0448\u0438\u0431\u043A\u0438"))),
                                React.createElement(TableBody, null, validatedRows.map((row) => (React.createElement(TableRow, { key: row.rowNumber, sx: (theme) => (Object.assign({}, (row.isValid
                                        ? {}
                                        : {
                                            bgcolor: alpha(theme.palette.error.main, 0.06),
                                        }))) },
                                    React.createElement(TableCell, null, row.rowNumber),
                                    React.createElement(TableCell, null, row.preview.name),
                                    React.createElement(TableCell, null, row.preview.number),
                                    React.createElement(TableCell, null, row.preview.volume),
                                    React.createElement(TableCell, null, row.preview.group_name),
                                    React.createElement(TableCell, null, row.preview.imei),
                                    React.createElement(TableCell, null, row.preview.device_type_name),
                                    React.createElement(TableCell, null, row.isValid ? (React.createElement(CheckCircleRounded, { fontSize: 'small', color: 'success' })) : (React.createElement(ErrorRounded, { fontSize: 'small', color: 'error' }))),
                                    React.createElement(TableCell, null, row.errors.length ? (React.createElement(Typography, { variant: 'caption', color: 'error' }, row.errors.join('; '))) : (React.createElement(Typography, { variant: 'caption', color: 'text.secondary' }, "\u2014"))))))))))),
                    !validatedRows.length && !parseError && (React.createElement(Stack, { alignItems: 'center', justifyContent: 'center', spacing: 1, sx: (theme) => ({
                            py: 6,
                            border: '1px dashed',
                            borderColor: theme.palette.divider,
                            borderRadius: theme.shape.borderRadius,
                            color: 'text.secondary',
                        }) },
                        React.createElement(FileUploadRounded, null),
                        React.createElement(Typography, { variant: 'body2' }, "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u044B\u0439 Excel-\u0444\u0430\u0439\u043B \u0434\u043B\u044F \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u043F\u0440\u0435\u0432\u044C\u044E")))))),
        React.createElement(DialogActions, null,
            React.createElement(Typography, { variant: 'caption', color: 'text.secondary' }, "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F: \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435, \u0441\u0442\u0440\u0430\u043D\u0430, \u043E\u0431\u044A\u0435\u043C \u0431\u0430\u043A\u0430, \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u0430\u044F \u0433\u0440\u0443\u043F\u043F\u0430, IMEI, \u0442\u0438\u043F \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430."),
            React.createElement(Stack, { direction: 'row', spacing: 1 },
                React.createElement(LoadingButton, { variant: 'outlined', onClick: handleClose, disableElevation: true }, "\u041E\u0442\u043C\u0435\u043D\u0430"),
                React.createElement(LoadingButton, { variant: 'contained', loading: isSubmitLoading, disabled: !canImport, onClick: handleImport, disableElevation: true },
                    "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C ",
                    validCount > 0 ? `(${validCount})` : '')))));
};
export default TransportBulkImportDialog;
